export const STATUS_UPDATE_INTERVAL_MS = 60000;
export const MILLISECONDS_PER_MINUTE = 60000;